import { useMemo } from 'react';
import { PredefinedOption } from 'components/day-picker/DayPicker';
import { DUE_DATE_OPTIONS } from 'containers/settings/constants';
import { getDueDate } from 'containers/invoices/create-invoice/util';

// Constant for the "Upon receipt" label used across components
export const UPON_RECEIPT_LABEL = 'Upon receipt';

/**
 * Custom hook to generate predefined due date options
 * @param invoiceDate - The base invoice date to calculate due dates from
 * @returns Array of predefined due date options including custom option
 */
export const useDueDateOptions = (invoiceDate: Date): PredefinedOption[] => {
  return useMemo(() => {
    const mappedOptions = DUE_DATE_OPTIONS.map(option => {
      // Calculate date by adding duration days to invoice date
      const calculatedDate = getDueDate(invoiceDate, option.duration);
      return {
        label: option.id === 'due-on-receipt' ? UPON_RECEIPT_LABEL : `In ${option.btnLabel}`,
        date: calculatedDate,
        closesOnSelect: true
      };
    });

    // Add Custom option - null date means it doesn't match any specific date
    const customOption: PredefinedOption = {
      label: 'Custom',
      date: null,
      closesOnSelect: false,
      isCustom: true // Flag to identify custom option
    };

    return [...mappedOptions, customOption];
  }, [invoiceDate]);
};
